"use strict";
exports.__esModule = true;
var FlexView_1 = require("./FlexView");
exports["default"] = FlexView_1.FlexView;



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/react-flexview/lib/index.js
// module id = 72
// module chunks = 0